import { REORDER_CATEGORY, FETCH_CATEGORIES } from '../constants/categories';

const getActiveStoreId = (getState) => {
  const { store } = getState().user;
  if (!store) return null;
  return getState().stores.list.find(({ name }) => name === store)?.id ?? null;
};

export const fetchCategories = () => async (dispatch, getState) => {
  const storeId = getActiveStoreId(getState);
  if (!storeId) return null;

  try {
    const res = await fetch(`/__/categories?storeId=${storeId}`, {
      credentials: 'include',
    });
    const categories = await res.json();
    return dispatch({ type: FETCH_CATEGORIES, categories });
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const addCategory =
  ({ name }, next) =>
  async (dispatch) => {
    let json = {};
    if (name) {
      try {
        const res = await fetch('/__/categories', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ name }),
        });
        json = await res.json();
        if (next) await next(json);
        return await dispatch(fetchCategories());
      } catch (err) {
        console.error(err);
        return null;
      }
    }
    return null;
  };

export const editCategory =
  ({ id, name, color }) =>
  async (dispatch) => {
    try {
      await fetch(`/__/categories/${id}`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ name, color }),
      });
      return await dispatch(fetchCategories());
    } catch (err) {
      console.error(err);
      return null;
    }
  };

export const removeCategory = (id) => async (dispatch) => {
  try {
    await fetch(`/__/categories/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    return await dispatch(fetchCategories());
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const reorderCategory =
  ({ startIndex, endIndex }) =>
  async (dispatch, getState) => {
    const storeId = getActiveStoreId(getState);
    if (!storeId) return null;

    dispatch({
      type: REORDER_CATEGORY,
      startIndex,
      endIndex,
    });

    try {
      await fetch('/__/categories_reorder', {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ storeId, startIndex, endIndex }),
      });
      return await dispatch(fetchCategories());
    } catch (err) {
      console.error(err);
      return null;
    }
  };
